@if (orderModel.orderStarted()) {
    <div class="order-summary" [ngClass]="{'highlighted': highlighted()}" woa-activatable
         (onActivate)="onOrderSummary.emit()">
        <woa-icon class="order-summary-icon" [name]="'shopping-cart'"></woa-icon>
        <span class="order-summary-count">
            {{ orderModel.totalItems() }}
        </span>
    </div>
}
